<!--
 * @Author: qiuwenjing qiuwenjing@vip56.cn
 * @Date: 2024-05-11 10:26:06
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2026-02-11 13:46:47
 * @FilePath: \projectManagementFrontd:\project\app\PosGarmentMerchant-Front\src\views\home\Home.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="sselectReturnProduct_main">
        <van-overlay :show="show" :lock-scroll="false">
            <div class="dm_form_box"  v-if="isFinishLoading">
                <div class="tit_box">
                    <span class="tit">{{isOnlineFail?'更改退款方式':'确定退款金额'}}</span>
					<div class="t_btn" @click="cancelFun">取消</div>
                </div>
                <div class="con">
					<div class="c_l">
						<div class="info_box">
							<div class="ib_t">
								<div class="it"><span class="label">退回金额:</span><span class="val">{{fmoney(form.returnPriceAll,2,true)}}</span></div>
								<div class="it"><span class="label">退货数量:</span><span class="val">{{form.returnNumAll}}</span></div>
							</div>
							<div class="ib_b">
								<div class="ib">订单支付方式:</div>
								<div class="ib ib2" v-if="form.cashPart||form.paymentMethod==2">现金: {{fmoney(form.cashPart)}}</div>
								<div class="ib ib2" v-if="form.cardPart||form.paymentMethod==1">会员卡: {{fmoney(form.cardPart)}}</div>
								<div class="ib ib2" v-if="form.weChatPart||form.paymentMethod==3">微信: {{fmoney(form.weChatPart)}}</div>
								<div class="ib ib2"  v-if="form.alipayPart||form.paymentMethod==4">支付宝: {{fmoney(form.alipayPart)}}</div>
								<div class="ib ib2" v-if="form.offlineWeChatPart||form.paymentMethod==13">线下微信: {{fmoney(form.offlineWeChatPart)}}</div>
								<div class="ib ib2" v-if="form.offlineAlipayPart||form.paymentMethod==14">线下支付宝: {{fmoney(form.offlineAlipayPart)}}</div>
							</div>
							<div class="order_no">
								{{form.orderNo}}
							</div>
							<img src="@/assets/padImg/xjt.png" class="icon_zs" />
						</div>
						<div class="pay_method_box">
							<div class="pmb_tit">退款方式</div>
							<div class="pmb_con">
								<div class="pc_line" v-if="form.memberId&&(form.paymentMethod==2||form.paymentMethod==1||form.paymentMethod==13||form.paymentMethod==14||(form.paymentMethod>4&&form.paymentMethod<12)||form.paymentMethod>14||((form.paymentMethod==3||form.paymentMethod==4)&&!isOnlineRefund)||isOnlineFail)">
									<div class="pl_l" :class="getVipPayStatus()">
										<img class="icon_pay" mode="widthFix" src="@/assets/padImg/p_vip.png" />
										<span>会员卡</span>
									</div>
									<div class="pl_input" :class="getInputStatus(2)" @click="selectInputFocus(2)">
										<span>{{nvipVal}}</span>
									</div>
								</div>
								<div class="pc_line" v-if="form.paymentMethod==2||form.paymentMethod==13||form.paymentMethod==14||(form.paymentMethod>4&&form.paymentMethod<12)||form.paymentMethod>14||((form.paymentMethod==3||form.paymentMethod==4)&&!isOnlineRefund)||isOnlineFail">
									<div class="pl_l" :class="getCashPayStatus()">
										<img class="icon_pay" mode="widthFix" src="@/assets/padImg/pay_c.png" />
										<span>现金</span>
									</div>
									<div class="pl_input" :class="getInputStatus(1)" @click="selectInputFocus(1)">
										<span>{{ncashVal}}</span>
									</div>
								</div>
								<div class="pc_line" v-if="form.paymentMethod==14||form.paymentMethod==15||form.paymentMethod==16||form.paymentMethod==19||form.paymentMethod==20||form.paymentMethod==22||form.paymentMethod==23">
									<div class="pl_l" :class="getOfflineAliPayStatus()" >
										<img class="icon_pay" mode="widthFix" src="@/assets/padImg/pay_a.png" />
										<span>线下支付宝</span>
									</div>
									<div class="pl_input" :class="getInputStatus(6)" @click="selectInputFocus(6)">
										<span>{{nofflinealiVal}}</span>
									</div>
								</div>
								<div class="pc_line" v-if="form.paymentMethod==13||form.paymentMethod==17||form.paymentMethod==18||form.paymentMethod==19||form.paymentMethod==21||form.paymentMethod==22||form.paymentMethod==23">
									<div class="pl_l" :class="getOfflineWechatPayStatus()" >
										<img class="icon_pay" mode="widthFix" src="@/assets/padImg/pay_w.png" />
										<span>线下微信</span>
									</div>
									<div class="pl_input" :class="getInputStatus(5)" @click="selectInputFocus(5)">
										<span>{{nofflinewechatVal}}</span>
									</div>
								</div>
								<div class="pc_line" v-if="form.paymentMethod==4&&!isOnlineFail">
									<div class="pl_l" :class="getAliPayStatus()">
										<img class="icon_pay" mode="widthFix" src="@/assets/padImg/pay_a.png" />
										<span>支付宝</span>
									</div>
									<div class="pl_input" :class="getInputStatus(4)" @click="selectInputFocus(4)">
										<span v-if="isOnlineRefund">{{naliVal}}</span>
										<span v-else>“线上原路退款”功能未开启</span>
									</div>
								</div>
								<div class="pc_line" v-if="form.paymentMethod==3&&!isOnlineFail">
									<div class="pl_l" :class="getWechatPayStatus()" >
										<img class="icon_pay" mode="widthFix" src="@/assets/padImg/pay_w.png" />
										<span>微信</span>
									</div>
									<div class="pl_input" :class="getInputStatus(3)" @click="selectInputFocus(3)">
										<span v-if="isOnlineRefund">{{nwechatVal}}</span>
										<span v-else>“线上原路退款”功能未开启</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="c_r">
						<div class="key-board" >
                        <div class="keys">
                            <div class="key_l">
                                <div class="key button" v-for="num in config.loop" :key="num.key" @click.stop="number(num.number)">{{num.number}}</div>
                                <div class="key button" @click.stop="number(0)">0</div>
                                <div class="key button" @click.stop="number('00')">00</div>

                                <div class="key button" @click.stop="number('.')">.</div>

                            </div>
                            <div class="key_r">
                                <div class="key button" @click.stop="del">
                                    <img src="@/assets/padImg/p_delete.png" style="width: 2.12vw;height: 1.76vw;" alt="" />
                                </div>
                                <div class="key button key3" @click.stop="clearFun" >清空</div>
                                <div class="key button key2" @click="confirmTk">
                                    退<br />款
                                </div>

                            </div>
                        </div>
                    </div>
					</div>
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import { TbShop } from '@/http/api_TbShop';
import {fmoney} from '@/common/money';
import calculate from '@/common/util/calculate';
import { Toast } from 'vant';
export default{
    components:{
	},
	props:{
		show:{
			type:Boolean,
			default:false
		},
		form:{
			type:Object,
			default:()=>{
			    return {}
			}
		},
		isOnlineFail:{
			type:Boolean,
			default:false
		},
		isReturning:{
			type:Boolean,
			default:false
		},
	},
	data(){
		return{
			/**键盘 */
			config:{
			    loop : [
			        {
			            number : 1,
			            key : 'number-1',
			        },
			        {
			            number : 2,
			            key : 'number-2',
			        },
			        {
			            number : 3,
			            key : 'number-3',
			        },
			        {
			            number : 4,
			            key : 'number-4',
			        },
			        {
			            number : 5,
			            key : 'number-5',
			        },
			        {
			            number : 6,
			            key : 'number-6',
			        },
			        {
			            number : 7,
			            key : 'number-7',
			        },
			        {
			            number : 8,
			            key : 'number-8',
			        },
			        {
			            number : 9,
			            key : 'number-9',
			        },
			    ]
			},
			value: null,
			maxLength: 6,
			isNeedDot: true,
			/**当前选中输入框-数字键盘选中用
			 * 1:现金
			 * 2：会员卡
			 * 3：微信
			 * 4：支付宝
			 * 5：线下微信
			 * 6：线下支付宝
			 */
			inputType:null,
			/**输入框是否选中，首次点击输入框，清空数值用 */
			isInputSelected: false,
			/**支付方式 */
			payOptions: [
			  {
			    text: "会员卡支付",
			    value: 1,
			  },
			  {
			    text: "现金支付",
			    value: 2,
			  },
			  {
			    text: "微信支付",
			    value: 3,
			  },
			  {
			    text: "支付宝支付",
			    value: 4,
			  },
			  {
			    text: "现金+会员卡+微信",
			    value: 5,
			  },
			  {
			    text: "现金+会员卡+支付宝",
			    value: 6,
			  },
			  {
			    text: "现金+微信",
			    value: 7,
			  },
			  {
			    text: "现金+支付宝",
			    value: 8,
			  },
			  {
			    text: "会员卡+微信",
			    value: 9,
			  },
			  {
			    text: "会员卡+支付宝",
			    value: 10,
			  },
			  {
			    text: "现金+会员卡",
			    value: 11,
			  },
			  {
			    text: "线下微信",
			    value: 13,
			  },
			  {
			    text: "线下支付宝",
			    value: 14,
			  },
			  {
			    text: "现金+线下支付宝",
			    value: 15,
			  },
			  {
			    text: "会员卡+线下支付宝",
			    value: 16,
			  },
			  {
			    text: "现金+线下微信",
			    value: 17,
			  },
			  {
			    text: "会员卡+线下微信",
			    value: 18,
			  },
			  {
			    text: "线下微信+线下支付宝",
			    value: 19,
			  },
			  {
			    text: "现金+会员卡+线下支付宝",
			    value: 20,
			  },
			  {
			    text: "现金+会员卡+线下微信",
			    value: 21,
			  },
			  {
			    text: "现金+线下支付宝+线下微信",
			    value: 22,
			  },
			  {
			    text: "会员卡+线下支付宝+线下微信",
			    value: 23,
			  },
			],
			fmoney:fmoney,
			ncashVal:0,
			nvipVal:0,
			nwechatVal:0,
			naliVal:0,
			nofflinewechatVal:0,
			nofflinealiVal:0,
			/**选中的支付方式
			 * 支持多选，最多三个
			 * 1：现金
			 * 2：会员卡
			 * 3：微信
			 * 4：支付宝
			 */
			selectedPayType:[],
			isOnlineRefund:false,
			isFinishLoading:false,
		}
	},
	computed:{
		/**实退总额 */
		returnTotal(){
		   let val = 0;
		   let cashVal = this.ncashVal?this.ncashVal:0;
		   let vipVal = this.nvipVal?this.nvipVal:0;
		   let wechatVal = this.nwechatVal?this.nwechatVal:0;
		   let aliVal = this.naliVal?this.naliVal:0;
		   let offlineWechatVal = this.nofflinewechatVal?this.nofflinewechatVal:0;
		   let offlineAliVal = this.nofflinealiVal?this.nofflinealiVal:0;
		   val = calculate.addition(calculate.addition(calculate.addition(calculate.addition(calculate.addition(Number(cashVal),Number(vipVal)),Number(wechatVal)),Number(aliVal)),Number(offlineWechatVal)),Number(offlineAliVal));
		   return val;
		},
		/**判断是否只有一种支付方式 */
		isOnlyOne(){
			let val = false;
			if(this.form.paymentMethod==1){
				val = true;
			}
			if((this.form.paymentMethod==2||this.form.paymentMethod==7||this.form.paymentMethod==8||this.form.paymentMethod==9||this.form.paymentMethod==10)&&!this.form.memberId){
				val = true;
			}
			if(this.isOnlineFail){
				if((this.form.paymentMethod==3||this.form.paymentMethod==4)&&!this.form.memberId){
					val = true;
				}
			}else{
				if(this.form.paymentMethod==3||this.form.paymentMethod==4){
					val = true;
				}
				
			}
			return val;
		}
	},

    created() {
    },

    async mounted() {
       if(this.isOnlineFail){
       		await this.getAuth();
       		if(this.form.memberId){
       			this.selectedPayType.push(1,2);
       			this.nvipVal = this.form.returnPriceAll;
       		}else{
       			this.selectedPayType.push(1);
       			this.ncashVal = this.form.returnPriceAll;
       		}

       	}else{
       		switch (this.form.paymentMethod){
       			case 1:
       				this.selectedPayType=[2];
       				this.nvipVal = this.form.returnPriceAll;
       				break;
       			case 2:
       				if(this.form.memberId){
       					this.selectedPayType.push(1,2);
       				}else{
       					this.selectedPayType.push(1);
       				}
       				this.ncashVal = this.form.returnPriceAll;
       				   break;
       			case 3:
       				await this.getAuth();
       				if(this.isOnlineRefund){
       					this.selectedPayType.push(3);
       					this.nwechatVal = this.form.returnPriceAll;
       				}else{
       					if(this.form.memberId){
       						this.selectedPayType.push(1,2);
       						this.nvipVal = this.form.returnPriceAll;
       					}else{
       						this.selectedPayType.push(1);
       						this.ncashVal = this.form.returnPriceAll;
       					}
       				}
       				break;
       			case 4:
       				await this.getAuth();
       				if(this.isOnlineRefund){
       					this.selectedPayType.push(4);
       					this.naliVal = this.form.returnPriceAll;
       				}else{
       					if(this.form.memberId){
       						this.selectedPayType.push(1,2);
       						this.nvipVal = this.form.returnPriceAll;
       					}else{
       						this.selectedPayType.push(1);
       						this.ncashVal = this.form.returnPriceAll;
       					}
       				}
       				break;
       			case 5:
       				this.selectedPayType=[1,2];
       				this.nvipVal = this.form.returnPriceAll;
       				break;
       			case 6:
       				this.selectedPayType=[1,2];
       				this.nvipVal = this.form.returnPriceAll;
       				break;
       			case 7:
       				if(this.form.memberId){
       					this.selectedPayType.push(1,2);
       					this.nvipVal = this.form.returnPriceAll;
       				}else{
       					this.selectedPayType.push(1);
       					this.ncashVal = this.form.returnPriceAll;
       				}
       				break;
       			case 8:
       				if(this.form.memberId){
       					this.selectedPayType.push(1,2);
       					this.nvipVal = this.form.returnPriceAll;
       				}else{
       					this.selectedPayType.push(1);
       					this.ncashVal = this.form.returnPriceAll;
       				}
       				break;
       			case 9:
       				this.selectedPayType=[1,2];
       				this.nvipVal = this.form.returnPriceAll;
       				break;
       			case 10:
       				this.selectedPayType=[1,2];
       				this.nvipVal = this.form.returnPriceAll;
       				break;
       			case 11:
       				this.selectedPayType=[1,2];
       				this.nvipVal = this.form.returnPriceAll;
       				break;
       			case 13:
       				if(this.form.memberId){
       					this.selectedPayType=[1,2,5];
       				}else{
       					this.selectedPayType=[1,5];
       				}
       				this.nofflinewechatVal = this.form.returnPriceAll;
       				break;
       			case 14:
       				if(this.form.memberId){
       					this.selectedPayType=[1,2,6];
       				}else{
       					this.selectedPayType=[1,6];
       				}
       				this.nofflinealiVal = this.form.returnPriceAll;
       				break;
       			case 15:
       				if(this.form.memberId){
       					this.selectedPayType=[1,2,6];
       					this.nvipVal = this.form.returnPriceAll;
       				}else{
       					this.selectedPayType=[1,6];
       					this.ncashVal = this.form.returnPriceAll;
       				}
       				break;
       			case 16:
       				this.selectedPayType=[1,2,6];
       				this.nvipVal = this.form.returnPriceAll;
       				break;
       			case 17:
       				if(this.form.memberId){
       					this.selectedPayType=[1,2,5];
       					this.nvipVal = this.form.returnPriceAll;
       				}else{
       					this.selectedPayType=[1,5];
       					this.ncashVal = this.form.returnPriceAll;
       				}
       				break;
       			case 18:
       				this.selectedPayType=[1,2,5];
       				this.nvipVal = this.form.returnPriceAll;
       				break;
       			case 19:
       				if(this.form.memberId){
       					this.selectedPayType=[1,2,5,6];
       					this.nvipVal = this.form.returnPriceAll;
       				}else{
       					this.selectedPayType=[1,5,6];
       					this.ncashVal = this.form.returnPriceAll;
       				}
       				break;
       			case 20:
       				this.selectedPayType=[1,2,6];
       				this.nvipVal = this.form.returnPriceAll;
       				break;
       			case 21:
       				this.selectedPayType=[1,2,5];
       				this.nvipVal = this.form.returnPriceAll;
       				break;
       			case 22:
       				if(this.form.memberId){
       					this.selectedPayType=[1,2,5,6];
       					this.nvipVal = this.form.returnPriceAll;
       				}else{
       					this.selectedPayType=[1,5,6];
       					this.ncashVal = this.form.returnPriceAll;
       				}
       				break;
       			case 23:
       				if(this.form.memberId){
       					this.selectedPayType=[1,2,5,6];
       					this.nvipVal = this.form.returnPriceAll;
       				}else{
       					this.selectedPayType=[1,2,5,6];
       					this.nvipVal = this.form.returnPriceAll;
       				}
       				break;
       			   default:
       				   break;
       		   }
       	}
       	   this.value =  this.form.returnPriceAll;
		   this.$nextTick(()=>{
			   this.isFinishLoading = true;
		   })
    },
	methods:{
		/**获取权限 */
		async getAuth(){
			let res = await TbShop.GetInitShopInfo({shopId:JSON.parse(localStorage.getItem('padShopInfo')).id});
			this.isOnlineRefund = res.isOnlineRefund;
		},
		/**键盘 */
		del() {
			if(this.value){
		        let index = this.value.length;
		        this.value = index==1?0: this.value.toString().slice(0,index-1);
		    }else{
		        this.value = 0;
		    }
			this.finishFun();
		},
		number(number) {
			// this.$emit("number", number);
		    if(number=='.'&&!this.isNeedDot) return;
			let val = this.value;
			let dotIndex = this.value?this.value.toString().indexOf('.'):-1;
			if(number=='.'&&dotIndex>-1||this.value&&this.value.toString().length==this.maxLength) return;
			this.value = this.value?this.value.toString() + number.toString():number.toString();
			if(dotIndex>-1){
				if(val.toString().slice(dotIndex+1).length>1){
					this.value = this.value.slice(0,dotIndex+3)
				}
			}else{
				this.value = this.value.slice(0,this.maxLength)
			}
			this.finishFun();
		},
		clearFun(){
			this.value = null;
			this.finishFun();
		},
		finishFun(){
		    let value = this.value?this.value:0;
		    // let value = this.value;
		    switch (this.inputType) {
		        case 1:
		            this.ncashVal = value;
		            /**判断是否超出应收 */
		            this.$nextTick(()=>{
		                if(this.ncashVal>this.form.returnPriceAll&&this.selectedPayType.length>1){
		                   this.ncashVal = this.form.returnPriceAll;
		                   this.value = this.form.returnPriceAll;
		                }
		                this.calcOhterVal(1,this.ncashVal)
		            })
					 break;
		        case 2:
		            this.nvipVal = value;
		            /**判断是否超出应收 */
		            this.$nextTick(()=>{
		                if(this.nvipVal>this.form.returnPriceAll&&this.selectedPayType.length>1){
		                   this.nvipVal = this.form.returnPriceAll;
		                   this.value = this.form.returnPriceAll;
		                }
		                this.calcOhterVal(2,this.nvipVal)
		            })
		            break;
		        case 3:
		            this.nwechatVal = value;
		            /**判断是否超出应收 */
		            this.$nextTick(()=>{
		                if(this.nwechatVal>this.form.returnPriceAll&&this.selectedPayType.length>1){
		                   this.nwechatVal = this.form.returnPriceAll;
		                   this.value = this.form.returnPriceAll;
		                }
		                this.calcOhterVal(3,this.nwechatVal)
		            })
		            break;
		        case 4:
		            this.naliVal = value;
		            /**判断是否超出应收 */
		            this.$nextTick(()=>{
		                if(this.naliVal>this.form.returnPriceAll&&this.selectedPayType.length>1){
		                   this.naliVal = this.form.returnPriceAll;
		                   this.value = this.form.returnPriceAll;
		                }
		                this.calcOhterVal(4,this.naliVal)
		            })
		            break;
		        case 5:
		            this.nofflinewechatVal = value;
		            /**判断是否超出应收 */
		            this.$nextTick(()=>{
		                if(this.nofflinewechatVal>this.form.returnPriceAll){
		                   this.nofflinewechatVal = this.form.returnPriceAll;
		                   this.value = this.form.returnPriceAll;
		                }
		                this.calcOhterVal(5,this.nofflinewechatVal)
		            })
		            break;
		        case 6:
		            this.nofflinealiVal = value;
		            /**判断是否超出应收 */
		            this.$nextTick(()=>{
		                if(this.nofflinealiVal>this.form.returnPriceAll){
		                   this.nofflinealiVal = this.form.returnPriceAll;
		                   this.value = this.form.returnPriceAll;
		                }
		                this.calcOhterVal(6,this.nofflinealiVal)
		            })
		            break;

		        default:
		            break;
		    }
			
		    this.isInputSelected = false;
		    this.$forceUpdate();
		},
		cancelFun(){
			this.$emit('cancelFun');
		},
		/**会员支付输入框-状态 */
		getVipPayStatus(){
		    let str = "";
		    if(this.selectedPayType.some(v=>v==2)){
		        str="isActive"
		    }
		    return str;
		},
		getCashPayStatus(){
		    let str = "";
		    if(this.selectedPayType.some(v=>v==1)){
		        str="isActive"
		    }
		    return str;
		},
		getOfflineAliPayStatus(){
		    let str = "";
		    if(this.selectedPayType.some(v=>v==6)){
		        str="isActive"
		    }
		    return str;
		},
		getOfflineWechatPayStatus(){
		    let str = "";
		    if(this.selectedPayType.some(v=>v==5)){
		        str="isActive"
		    }
		    return str;
		},
		getWechatPayStatus(){
		    let str = "";
			if(!this.isOnlineRefund){
				str="isDisabled"
			}
		    if(this.selectedPayType.some(v=>v==3)){
		        str="isActive"
		    }
		    return str;
		},
		getAliPayStatus(){
		    let str = "";
			if(!this.isOnlineRefund){
				str="isDisabled"
			}
		    if(this.selectedPayType.some(v=>v==4)){
		        str="isActive"
		    }
		    return str;
		},
		/**选择支付方式 */
		choosePayMethod(type){
			if(this.getWechatPayStatus()=='isDisabled'&&type==3) return;
			if(this.getAliPayStatus()=='isDisabled'&&type==4) return;
		   this.chargePayFun(type);
		    this.isInputSelected = false;
		},
		chargePayFun(val){
			this.inputType = null;
			if(!this.selectedPayType.some(v=>v==val)){
				// if(this.selectedPayType.length==3) return;
			    this.selectedPayType.push(val);
			    if(this.selectedPayType.length==1){
			        this.setInputVal(val);
			    }
			    this.calcOhterVal2(val)

			}else{
			    if(this.selectedPayType.length>1){
			        this.calcOhterVal(val,0);
			        this.clearInputVal(val);
			        this.selectedPayType = this.selectedPayType.filter(v=>v!=val);
			    }else{
					this.selectedPayType=[val];
					this.setInputVal(val);
				}
			}
		},
		setInputVal(val){
		    switch (val) {
		        case 1:
		            this.ncashVal = this.form.returnPriceAll;
		            this.nvipVal = 0;
		            this.nwechatVal = 0;
		            this.naliVal = 0;
					this.nofflinewechatVal = 0;
					this.nofflinealiVal = 0;
		            break;
		        case 2:
		            this.ncashVal = 0;
		            this.nvipVal = this.form.returnPriceAll;
		            this.nwechatVal = 0;
		            this.naliVal = 0;
		            this.nofflinewechatVal = 0;
		            this.nofflinealiVal = 0;
		            break;
		        case 3:
		            this.ncashVal = 0;
		            this.nvipVal = 0;
		            this.nwechatVal = this.form.returnPriceAll;
		            this.naliVal = 0;
		            this.nofflinewechatVal = 0;
		            this.nofflinealiVal = 0;
		            break;
		        case 4:
		            this.ncashVal = 0;
		            this.nvipVal = 0;
		            this.nwechatVal = 0;
		            this.naliVal = this.form.returnPriceAll;
		            this.nofflinewechatVal = 0;
		            this.nofflinealiVal = 0;
		            break;
				case 5:
				    this.ncashVal = 0;
				    this.nvipVal = 0;
				    this.nwechatVal = 0;
				    this.naliVal = 0;
				    this.nofflinewechatVal = this.form.returnPriceAll;
				    this.nofflinealiVal = 0;
				    break;
				case 6:
				    this.ncashVal = 0;
				    this.nvipVal = 0;
				    this.nwechatVal = 0;
				    this.naliVal = 0;
				    this.nofflinewechatVal = 0;
				    this.nofflinealiVal = this.form.returnPriceAll;
				    break;

		        default:
		            break;
		    }
		},
		/**仅有2种，输入一种，自动算第二种，两者相加为应收 */
		calcOhterVal(nowType,nowVal){
		    if(this.selectedPayType.length!=2) return;
		    let otherType = this.selectedPayType.filter(v=>v!=nowType)[0];
		    let otherVal = calculate.subtraction(this.form.returnPriceAll,nowVal);
		    switch (otherType) {
		        case 1:
		            this.ncashVal = otherVal;
		            break;
		        case 2:
		            this.nvipVal = otherVal;
		            break;
		        case 3:
		            this.nwechatVal = otherVal;
		            break;
		        case 4:
		            this.naliVal = otherVal;
		            break;
				case 5:
				    this.nofflinewechatVal = otherVal;
				    break;
				case 6:
				    this.nofflinealiVal = otherVal;
				    break;

		        default:
		            break;
		    }
		},
		/**选择支付方式，如果选择2种，自动算第二种 */
		calcOhterVal2(nowType){
		    if(this.selectedPayType.length!=2) return;
		    let otherType = this.selectedPayType.filter(v=>v!=nowType)[0];
		    let otherVal = calculate.subtraction(this.form.returnPriceAll,this.returnTotal);
		    if(otherVal<0){
		        this.setInputVal(nowType);
		    }else{
		        switch (nowType) {
		            case 1:
		                this.ncashVal = otherVal;
		                break;
		            case 2:
		                this.nvipVal =otherVal;
		                break;
		            case 3:
		                this.nwechatVal = otherVal;
		                break;
		            case 4:
		                this.naliVal = otherVal;
		                break;
					case 5:
					    this.nofflinewechatVal = otherVal;
					    break;
					case 6:
					    this.nofflinealiVal = otherVal;
					    break;

		            default:
		                break;
		        }
		    }
		},
		clearInputVal(val){
		    switch (val) {
		        case 1:
		            this.ncashVal = 0;
		            break;
		        case 2:
		            this.nvipVal = 0;
		            break;
		        case 3:
		            this.nwechatVal = 0;
		            break;
		        case 4:
		            this.naliVal = 0;
		            break;
				case 5:
				    this.nofflinewechatVal = 0;
				    break;
				case 6:
				    this.nofflinealiVal = 0;
				    break;

		        default:
		            break;
		    }

		},
		/**支付方式，输入框状态 */
		getInputStatus(type){
		    let str = "";
		    switch (type) {
		        case 1:
		            if(this.inputType==1&&this.isInputSelected){
		                str="isActive"
		            }
		            break;
		        case 2:
		            if(this.inputType==2&&this.isInputSelected){
		                str="isActive"
		            }
		            break;
		        case 3:
		            if(!this.isOnlineRefund){
		                str = "isDisabled"
		            }else{
		                if(this.inputType==3&&this.isInputSelected){
		                    str="isActive"
		                }
		            }
		            break;
				case 4:
				    if(!this.isOnlineRefund){
				        str = "isDisabled"
				    }else{
				        if(this.inputType==4&&this.isInputSelected){
				            str="isActive"
				        }
				    }
				    break;
				case 5:
				    if(this.inputType==5&&this.isInputSelected){
				        str="isActive"
				    }
				    break;
				case 6:
				    if(this.inputType==6&&this.isInputSelected){
				        str="isActive"
				    }
				    break;

		        default:
		            break;
		    }
		    return str;
		},
		selectInputFocus(type){
			if(this.isOnlyOne) return;
			if(type==3&&this.getInputStatus(3)=='isDisabled') return;
			if(type==4&&this.getInputStatus(4)=='isDisabled') return;
		    this.inputType = type;
		    this.isInputSelected = true;
		    this.value = null;
		},
		/**退款 */
		confirmTk(){
			if(this.isReturning)return;
			if(Number(this.returnTotal)>Number(this.form.returnPriceAll)){
        Toast("实退金额 不可大于 退回金额，请检查各退款金额")
				return;
			}
			if(Number(this.returnTotal)<Number(this.form.returnPriceAll)){
        Toast("实退金额 不可小于 退回金额，请检查各退款金额")
				return;
			}
			let obj = {
				cashVal:this.ncashVal,
				vipVal:this.nvipVal,
				wechatVal:this.nwechatVal,
				aliVal:this.naliVal,
				offlineWechatVal:this.nofflinewechatVal,
				offlineAliVal:this.nofflinealiVal,
				isOnlineRefund:this.isOnlineRefund
			}
			this.$emit('confirmFun',obj)
		}
	}




}
</script>

<style lang="scss" scoped>
@function px2vw($n) {
	@return ($n / 1366 * 100) * 1vw;
}
.sselectReturnProduct_main{
    position: fixed;
    z-index: 99;
	font-size: px2vw(12);
    .dm_form_box{
        width: px2vw(1141);
        background: #fff;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        border-radius: 0.29vw;
        height: px2vw(584);
        .tit_box{
            box-sizing: border-box;
            height: px2vw(80);
            border-bottom: 1PX solid #D8D8D8;
			box-sizing: border-box;
			text-align: center;
			line-height: px2vw(80);
			position: relative;
            .tit{
                font-size: px2vw(20);
                font-weight: bold;
                letter-spacing: 0px;
                color: #3D3D3D;
            }
			.t_btn{
				width: px2vw(120);
				height: px2vw(46);
				border-radius: px2vw(4);
				background: linear-gradient(252deg, #CEB57D 0%, #BFA05B 98%);
				font-size: px2vw(16);
				line-height: px2vw(46);
				font-weight: bold;
				color: #FFFFFF;
				position: absolute;
				top: px2vw(17);
				left: px2vw(14);
			}
        }
        .con{
            height: calc(100% - 5.86vw);
            position: relative;
			display: flex;
			.c_l{
				box-sizing: border-box;
				padding: px2vw(20) px2vw(40) px2vw(50) px2vw(40);
				background: #fff;
				width: px2vw(632);
				.info_box{
					width: 100%;
					height: px2vw(90);
					background: linear-gradient(103deg, #D9BC7C 21%, #D0B579 97%);
					color: #fff;
					border-radius: px2vw(12);
					position: relative;
					box-sizing: border-box;
					padding-top: px2vw(16);
					padding-left: px2vw(23);
					margin-bottom: px2vw(40);
					.order_no{
						position: absolute;
						right: 0;
						top: 0;
						background: rgba(255, 255, 255, 0.8);
						font-size: px2vw(14);
						line-height: px2vw(31);
						letter-spacing: 0px;
						color: #CEB57D;
						height: px2vw(31);
						box-sizing: border-box;
						padding-left: px2vw(20);
						padding-right: px2vw(12);
						border-radius: 0 0 0 6vw;
					}
					.icon_zs{
						position: absolute;
						width: px2vw(62.5);
						height: px2vw(49);
						top: 0;
						right: px2vw(115.5);
					}
					.ib_t{
						display: flex;
						align-items: center;
						margin-bottom: px2vw(11);
						.it{
							font-weight: bold;
							line-height: px2vw(20);
							margin-right: px2vw(24);
							&:last-child{
								margin-right: 0;
							}
							.label{
								font-size: px2vw(16);
								letter-spacing: 0px;
							}
							.val{
								font-size: px2vw(34);
								letter-spacing: 0px;
							}
						}
					}
					.ib_b{
						display: flex;
						align-items: center;
						font-size: px2vw(14);
						line-height: px2vw(20);
						.ib2{
							position: relative;
							padding-right: px2vw(16);
							margin-right: px2vw(16);
							&::after{
								content:'';
								width: 1px;
								height: px2vw(14);
								background: #fff;
								position: absolute;
								right: 0;
								top: 50%;
								transform: translate(0,-50%);
							}
							&:last-child{
								margin-right: 0;
								&::after{
									display: none;
								}
							}
						}
						.ib_line{
							width: 1px;
							height: px2vw(14);
							background: #fff;
							margin: 0 px2vw(16);
						}
					}
				}
				.pay_method_box{
					box-sizing: border-box;
					.pmb_tit{
						font-size: px2vw(16);
						line-height: px2vw(20);
						letter-spacing: 0px;
						color: #4E5969;
						margin-bottom: px2vw(14);
					}
					.pmb_con{
						.pc_line{
							display: flex;
							align-items: center;
							margin-bottom: px2vw(10);
							&:last-child{
								margin-bottom: 0;
							}
							.pl_l{
								width: px2vw(183);
								height: px2vw(60);
								border-radius: px2vw(4);
								box-sizing: border-box;
								border: 1px solid #D8DCE5;
								display: flex;
								align-items: center;
								font-size: px2vw(20);
								line-height: px2vw(20);
								letter-spacing: 0px;
								color: #1A1A1A;
								padding-left: px2vw(20);
								margin-right: px2vw(12);
								&.isActive{
									// border-color: #CEB57D;
								}
								&.isDisabled{
									background: #F7F8FA;
									opacity: 0.6;
								}
								.icon_pay{
									width: px2vw(30);
									margin-right: px2vw(13);
								}
							}
							.pl_input{
								width: px2vw(357);
								height: px2vw(60);
								border-radius: px2vw(4);
								box-sizing: border-box;
								border: 1px solid #D8DCE5;
								font-size: px2vw(20);
								letter-spacing: 0px;
								color: #212121;
								display: flex;
								align-items: center;
								flex-direction: row-reverse;
								padding-right: px2vw(12);
								&.isActive{
									border-color: #CEB57D;
								}
								&.isDisabled{
									background: #F7F8FA;
									opacity: 0.6;
								}
							}
						}
					}
				}
			}
			.c_r{
				.key-board {
					width: 100%;
					height: 100%;
					background: rgba(214, 217, 223, 0.3);
					box-sizing: border-box;
					padding:px2vw(36) px2vw(40);
					padding-bottom: 0;
					.title {
						display: flex;
						justify-content: center;
						align-items: center;
						height: 14.19vh;
						background: #eeeeee;
					}
					.keys {
						display: flex;
						width: 100%;
						.key_l{
							display: flex;
							flex-wrap: wrap;
							.key{
								margin-right: px2vw(10);
								margin-bottom: px2vw(10);
								&:nth-child(3n){
									margin-right: 0;
								}
							}
						}
						.key_r{
							width: px2vw(100);
							.key{
								margin-bottom: px2vw(10);
							}
							.key2{
								height: px2vw(210);
								background: #DF4139;
								font-size: px2vw(30);
								font-weight: bold;
								text-align: center;
								letter-spacing: 0px;
								color: #FFFFFF;
								line-height: 4.95vh;
							}
							.key3{
								font-size: px2vw(24);
								font-weight: bold;
								color: #FA5151;
							}
						}
						.key {
							width: px2vw(100);
							height: px2vw(100);
							display: flex;
							justify-content: center;
							align-items: center;
							box-sizing: border-box;
							background: #ffffff;
							font-size: px2vw(30);
							line-height: px2vw(100);
							text-align: center;
							letter-spacing: 0px;
							color: #4E5969;
							border-radius: px2vw(8);
						}

					}

				}
			}
        }
    }
}

::-webkit-scrollbar {
    display: none;
}

</style>



// WEBPACK FOOTER //
// src/views/padViews/cashier/components/confirmReturnPanel.vue